import { render, staticRenderFns } from "./ProductDlivyRegistration.vue?vue&type=template&id=5b1adcf3&scoped=true&"
import script from "./ProductDlivyRegistration.vue?vue&type=script&lang=js&"
export * from "./ProductDlivyRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ProductDlivyRegistration.vue?vue&type=style&index=0&id=5b1adcf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1adcf3",
  null
  
)

export default component.exports